// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
  width: 100%;
  font-size: 16px;
  font-weight: 100;
  color: #999999;
  text-align: center;
  display: inline-block;
}
.error:first-child {
  margin-top: 100px;
}

.card {
  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.05);
  height: 320px;
  overflow: hidden;
}
.card:last-child {
  margin-bottom: 27.5px;
}

.title {
  width: 100%;
  font-size: 16px;
  margin-bottom: 35px;
  display: inline-block;
}
.title .bold {
  font-weight: 600;
}

.container-datepicker {
  position: absolute;
  top: -7px;
  right: 0px;
}

.valor-vendas-hoje {
  margin-top: 0px;
  font-size: 60px;
  margin-bottom: 10px;
  position: relative;
  display: inline-block;
  left: 50%;
  transform: translateX(-50%);
}
.valor-vendas-hoje span {
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(to right, #4378ff 40%, #8e42ff 100%);
}
.valor-vendas-hoje span:first-child {
  font-size: 30px;
  margin-right: 5px;
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(to right, #22b5ff 70%, #4378ff 100%);
}
.valor-vendas-hoje span:last-child {
  font-size: 40px;
  color: transparent;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(to right, #8e42ff 50%, #a42cff 100%);
}

.total-do-mes {
  padding: 10px 20px;
  background-image: linear-gradient(to right, #22b5ff 50%, #8e42ff 100%);
  border-radius: 9px;
  color: #fff;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
.total-do-mes .bold {
  font-weight: 600;
  margin: 0px 5px;
}
.total-do-mes span:nth-child(3) {
  font-size: 22px;
}
.total-do-mes span:nth-child(4) {
  font-size: 30px;
}
.total-do-mes span:nth-child(5) {
  font-size: 22px;
}

.first-line, .second-line {
  margin-top: 50px;
}

.vendas-por-periodo {
  padding-left: 50px;
}

.second-line .block {
  float: left;
  height: 172px;
  width: 33.333333333%;
  text-align: center;
  font-size: 14px;
}
.second-line .block:nth-child(2) {
  color: #fff;
  background-image: linear-gradient(to top, rgba(164, 44, 255, 0.4), rgba(142, 66, 255, 0.9));
}
.second-line .block:nth-child(3) {
  color: #8e42ff;
  background-image: linear-gradient(to top, rgba(164, 44, 255, 0.15), rgba(142, 66, 255, 0.5));
}
.second-line .block:nth-child(4) {
  color: #8e42ff;
  background-image: linear-gradient(to top, rgba(164, 44, 255, 0.1), rgba(142, 66, 255, 0.4));
}
.second-line .block span {
  width: 100%;
  display: inline-block;
  position: relative;
  top: calc(50% - 10px);
  transform: translateY(-50%);
}
.second-line .block span:first-child {
  font-weight: 600;
}
.second-line .total-lancamentos {
  display: inline-block;
  width: 100%;
  text-align: right;
  margin-top: 20px;
}
.second-line .total-lancamentos span.bold {
  font-weight: 600;
  margin-left: 5px;
}
.second-line .total-lancamentos span:last-child {
  color: #8e42ff;
  font-size: 18px;
}

.container-bar-chart {
  height: 178px;
  position: relative;
  top: 0px;
}

.total-pagamentos {
  text-align: right;
  margin-bottom: 10px;
}
.total-pagamentos .bold {
  font-weight: 600;
  margin-right: 5px;
}
.total-pagamentos span:last-child {
  color: #8e42ff;
  font-weight: 400;
  font-size: 18px;
}

.container-area-chart {
  height: 215px;
}

.container-valor-vendas-hoje {
  max-width: 300px;
}

@media (max-width: 1200px) {
  .container-valor-vendas-hoje {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }
  .vendas-por-periodo {
    padding-left: 0px;
  }
  .vendas-hoje, .vendas-por-periodo {
    padding: 27.5px;
    padding-top: 0px;
  }
  .second-line {
    margin-top: 0px;
  }
}
@media (max-width: 400px) {
  .valor-total {
    display: inline-block;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/components/visao-geral/visao-geral.component.scss","webpack://./src/sass/_variables.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cCYU;EDXV,kBAAA;EACA,qBAAA;AADF;AAEE;EACE,iBAAA;AAAJ;;AAIA;EACE,iDAAA;EACA,aAAA;EACA,gBAAA;AADF;AAEE;EACE,qBAAA;AAAJ;;AAIA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AADF;AAEE;EACE,gBAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,2BAAA;AADF;AAEE;EACE,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,sEAAA;AAAJ;AACI;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,sEAAA;AACN;AACI;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,sEAAA;AACN;;AAIA;EACE,kBAAA;EACA,sEAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AADF;AAEE;EACE,gBAAA;EACA,eAAA;AAAJ;AAGI;EACE,eAAA;AADN;AAGI;EACE,eAAA;AADN;AAGI;EACE,eAAA;AADN;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAOE;EACE,WAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;AAJJ;AAKI;EACE,WAAA;EACA,2FAAA;AAHN;AAKI;EACE,cAAA;EACA,4FAAA;AAHN;AAKI;EACE,cAAA;EACA,2FAAA;AAHN;AAKI;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;AAHN;AAIM;EACE,gBAAA;AAFR;AAME;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAJJ;AAMM;EACE,gBAAA;EACA,gBAAA;AAJR;AAMM;EACE,cAAA;EACA,eAAA;AAJR;;AAUA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;AAPF;;AAUA;EACE,iBAAA;EACA,mBAAA;AAPF;AAQE;EACE,gBAAA;EACA,iBAAA;AANJ;AASI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAPN;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,gBAAA;AATF;;AAYA;EACE;IACE,kBAAA;IACA,SAAA;IACA,2BAAA;EATF;EAYA;IACE,iBAAA;EAVF;EAaA;IACE,eAAA;IACA,gBAAA;EAXF;EAcA;IACE,eAAA;EAZF;AACF;AAeA;EACE;IACE,qBAAA;IACA,WAAA;EAbF;AACF","sourcesContent":["@import '../../../../../sass/variables';\n\n.error {\n  width: 100%;\n  font-size: 16px;\n  font-weight: 100;\n  color: $cinza-500;\n  text-align: center;\n  display: inline-block;\n  &:first-child {\n    margin-top: 100px;\n  }\n}\n\n.card {\n  box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.05);\n  height: 320px;\n  overflow: hidden;\n  &:last-child {\n    margin-bottom: 27.5px;\n  }\n}\n\n.title {\n  width: 100%;\n  font-size: 16px;\n  margin-bottom: 35px;\n  display: inline-block;\n  .bold {\n    font-weight: 600;\n  }\n}\n\n.container-datepicker {\n  position: absolute;\n  top: -7px;\n  right: 0px;\n}\n\n.valor-vendas-hoje {\n  margin-top: 0px;\n  font-size: 60px;\n  margin-bottom: 10px;\n  position: relative;\n  display: inline-block;\n  left: 50%;\n  transform: translateX(-50%);\n  span {\n    color: transparent;\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-image: linear-gradient(to right, #4378ff  40%, #8e42ff 100%);\n    &:first-child {\n      font-size: 30px;\n      margin-right: 5px;\n      color: transparent;\n      background-clip: text;\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-image: linear-gradient(to right, #22b5ff 70%, #4378ff 100%);\n    }\n    &:last-child {\n      font-size: 40px;\n      color: transparent;\n      background-clip: text;\n      -webkit-background-clip: text;\n      -webkit-text-fill-color: transparent;\n      background-image: linear-gradient(to right, #8e42ff  50%, #a42cff 100%);\n    }\n  }\n}\n\n.total-do-mes {\n  padding: 10px 20px;\n  background-image: linear-gradient(to right, #22b5ff  50%, #8e42ff 100%);\n  border-radius: 9px;\n  color: #fff;\n  position: relative;\n  left: 50%;\n  transform: translateX(-50%);\n  .bold {\n    font-weight: 600;\n    margin: 0px 5px;\n  }\n  span {\n    &:nth-child(3) {\n      font-size: 22px;\n    }\n    &:nth-child(4) {\n      font-size: 30px;\n    }\n    &:nth-child(5) {\n      font-size: 22px;\n    }\n  }\n}\n\n.first-line, .second-line {\n  margin-top: 50px;\n}\n\n.vendas-por-periodo {\n  padding-left: 50px;\n}\n\n.second-line {\n  .block {\n    float: left;\n    height: 172px;\n    width: 33.333333333%;\n    text-align: center;\n    font-size: 14px;\n    &:nth-child(2) {\n      color: #fff;\n      background-image: linear-gradient(to top, rgba(#a42cff, 0.4), rgba(#8e42ff, 0.9));\n    }\n    &:nth-child(3) {\n      color: #8e42ff;\n      background-image: linear-gradient(to top, rgba(#a42cff, 0.15), rgba(#8e42ff, 0.5));\n    }\n    &:nth-child(4) {\n      color: #8e42ff;\n      background-image: linear-gradient(to top, rgba(#a42cff, 0.1), rgba(#8e42ff, 0.4));\n    }\n    span {\n      width: 100%;\n      display: inline-block;\n      position: relative;\n      top: calc(50% - 10px);\n      transform: translateY(-50%);\n      &:first-child {\n        font-weight: 600;\n      }\n    }\n  }\n  .total-lancamentos {\n    display: inline-block;\n    width: 100%;\n    text-align: right;\n    margin-top: 20px;\n    span {\n      &.bold {\n        font-weight: 600;\n        margin-left: 5px;\n      }\n      &:last-child {\n        color: #8e42ff;\n        font-size: 18px;\n      }\n    }\n  }\n}\n\n.container-bar-chart {\n  height: 178px;\n  position: relative;\n  top: 0px;\n}\n\n.total-pagamentos {\n  text-align: right;\n  margin-bottom: 10px;\n  .bold {\n    font-weight: 600;\n    margin-right: 5px;\n  }\n  span {\n    &:last-child {\n      color: #8e42ff;\n      font-weight: 400;\n      font-size: 18px;\n    }\n  }\n}\n\n.container-area-chart {\n  height: 215px;\n}\n\n.container-valor-vendas-hoje {\n  max-width: 300px;\n}\n\n@media (max-width: 1200px) {\n  .container-valor-vendas-hoje {\n    position: relative;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  .vendas-por-periodo {\n    padding-left: 0px;\n  }\n\n  .vendas-hoje, .vendas-por-periodo {\n    padding: 27.5px;\n    padding-top: 0px;\n  }\n\n  .second-line {\n    margin-top: 0px;\n  }\n}\n\n@media (max-width: 400px) {\n  .valor-total {\n    display: inline-block;\n    width: 100%;\n  }\n}\n","// -------\n// Paleta de Cores\n// -------\n\n// Cores da Identidade - Listadas com base no gradiente principal\n\n$azul-200: #00f6ff;\n$azul-300: #00caff;\n$azul-400: #22b7ff;\n$azul-500: #4379ff;\n$violeta: #6a5cff;\n$roxo-500: #8e42ff;\n$roxo-400: #a42cff;\n$roxo-300: #a900ff;\n\n// Tons neutros \n\n$cinza-600: #777777;     //textos \"on\" - textos principais\n$cinza-500: #999999;     //textos \"off\" - textos auxiliares\n$cinza-400: #cccccc;      \n$cinza-300: #e2e2e2;     //bordas - menos vivo que o texto off\n$cinza-200: #e6e6e6;     //Para bullet points, e etc.\n$cinza-100: #ececec;     //tom mais claro de cinza após o background\n\n$background-common: #f7f7f7;\n$white: #fff;\n\n// Cores padrões\n\n$primary: $violeta;\n$secondary: $cinza-200;\n$success: $azul-500;\n$info: $azul-400;\n$warning: #edaf80;\n$danger: #e57373;\n$inverse: $cinza-500;\n\n\n//fontes - variáveis\n\n$fonte-pague-la: \"Pague.la\", \"Open Sans\", sans-serif;\n$fonte-open-sans: \"Open Sans\", sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
